<div class="row">
  <div class="col">
    <h2><em class="fas fa-users"></em> Apsis One Users</h2>
  </div>
</div>

<div class="row no-gutters">
  <div class="offset-4 col-8">
    <div class="tabs">
      <ng-container *ngFor="let tab of tabs">
        <div
          (click)="changeTab(tab.id)"
          class="tab"
          [class.active]="activeTab === tab.id"
        >
          {{ tab.value }}
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="row search-bar">
  <div class="col-4">
    <app-search-bar
      placeholder="Find users by email (min 3 characters)"
      [searchQuery]="query"
      (handleSearch)="search($event)"
    ></app-search-bar>
  </div>
  <div class="col-8 filter-wrapper">
    <ng-container *ngIf="activeTab === 'users'">
      <div [@slideInOut]>
        <app-user-role-search
          [userRolesSearch]="roleArray"
          [userRolesArray]="userRoles$ | async"
          [userPermissions]="userPermissions$ | async"
          [roleType]="roleTypes.User"
          (search)="changeRoles($event)"
        >
        </app-user-role-search>
      </div>
    </ng-container>

    <ng-container
      *ngIf="activeTab === 'account-users' && !(loadingFilter$ | async)"
    >
      <div [@slideInOut]>
        <app-user-role-search
          [userRolesSearch]="roleArray"
          [userRolesArray]="userRoles$ | async"
          [userPermissions]="userPermissions$ | async"
          [roleType]="roleTypes.AccountUser"
          (search)="changeRoles($event)"
        >
        </app-user-role-search>

        <app-account-user-advanced-filter
          [accountCategories]="accountCategories$ | async"
          [selectedAccountCategories]="categoryArray"
          [permissions]="permissions$ | async"
          [licenses]="licenses$ | async"
          [loadingFilter]="loadingFilter$ | async"
          [showLicenseFilter]="showLicenceFilter"
          [selectedLicenses]="licenseArray"
          [selectedPermissions]="permissionArray"
          (showHideLicensesFilter)="showHideLicensesFilter($event)"
          (categoriesChange)="changeAccountCategory($event)"
          (selectPermission)="selectPermission($event)"
        >
        </app-account-user-advanced-filter>
      </div>
    </ng-container>
  </div>
</div>

<div #bulkEditList>
  <div *ngIf="editUsers && (selectedUsers$ | async).length">
    <app-user-bulk-edit
      [selectedUsers]="selectedUsers$ | async"
      [permissions]="permissionArray"
      (approveChangePermissions)="approveChangePermissions()"
    >
    </app-user-bulk-edit>
  </div>
</div>

<div
  *ngIf="
    activeTab === 'account-users' &&
    (users$ | async).length &&
    !(isSearching$ | async)
  "
  class="row"
>
  <div class="col">
    <b>Total: {{ permissionUserCount$ | async }}</b>
  </div>
  <div *ngIf="boUserCanRead" class="col-auto ml-auto">
    <div ngbDropdown class="d-inline-block">
      <button
        class="btn btn-sm btn-success"
        id="dropdownMenuButton"
        ngbDropdownToggle
      >
        Download CSV
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
        <button ngbDropdownItem (click)="exportAccountUsers(true)">
          All account users
        </button>
        <button ngbDropdownItem (click)="exportAccountUsers(false)">
          Unique users
        </button>
      </div>
    </div>
  </div>
</div>

<app-user-list
  [isLoadingUsers]="isSearching$ | async"
  [users]="users$ | async"
  [accountUserSearch]="!!(activeTab === 'account-users')"
  [selectedUsers]="selectedUsers$ | async"
  [selectedPermissions]="permissionArray"
  (editSelectedUsers)="editSelectedUsers()"
  (selectUser)="selectUser($event)"
  (selectAllUsers)="selectAllUsers($event)"
  (navigate)="goTo($event)"
></app-user-list>
